module.exports = __webpack_public_path__ + "static/orga2022-903a618dae34b68208b7dbc7fa6a9904.png";